module.exports = __webpack_public_path__ + "img/burgheim_fresken_2014_ref.447dbcb7.jpg";